
<span class="PGSelect {{readonly ? 'PGSelect--ReadOnly' : 'PGSelect--NotReadOnly'}}">
    @if (viewAs == null) {
        <app-pg-loading></app-pg-loading>
    }
    @if (viewAs == 'checkboxes') {
        <span class="PGSelect-Checkboxes input-group" role="group" [attr.aria-label]="ariaLabel">
            <div class="row">
                @if (getVisibleOptions(); as visibleOptions) {
                    @for (option of visibleOptions; track option) {
                        <div class="col PGSelect-FlexFixRealElement">
                            <label class="PGSelect-Checkboxes-Item d-block border rounded {{ readonly ? 'bg-grey' : 'bg-white' }}">
                                <div>
                                    <app-pg-switch [readonly]="readonly || option.disabled" [small]="true" [little]="true" [ariaLabel]="option.view | stripHTML" [ngModel]="isOptionSelected(option)" (ngModelChange)="onSwitchChange($event, option)"></app-pg-switch>
                                    <div>
                                        <span [innerHTML]="option.view"></span>
                                        @if (option.tooltip) {
                                            <div class="form-text text-muted">{{option.tooltip}}</div>
                                        }
                                    </div>
                                </div>
                            </label>
                        </div>
                    }
                }
                <!-- Perdoname madre por mi vida lamer -->
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
            </div>
        </span>
    }
    @if (viewAs == 'radios') {
        <span class="PGSelect-Radios input-group" role="radiogroup" [attr.aria-label]="ariaLabel" [attr.aria-required]="required || null">
            <div class="row">
                @if (getVisibleOptions(); as visibleOptions) {
                    @if(!required && !readonly) {
                        <div class="col PGSelect-FlexFixRealElement PGSelect-FlexFixRealElement--NoSelection">
                            <label class="PGSelect-Radios-Item d-block border rounded">
                                <div (click)="onSwitchChange(true, null)">
                                    <app-pg-switch [readonly]="true" [small]="true" [little]="true" value="-" [ariaLabel]="'pg-select.no-selection' | locTranslate" [ngModel]="value == null ? '-' : null"></app-pg-switch>
                                    <div>
                                        <span>{{ 'pg-select.no-selection' | locTranslate }}</span>
                                    </div>
                                </div>
                            </label>
                        </div>
                    }
                    @for (option of visibleOptions; track option) {
                        <div class="col PGSelect-FlexFixRealElement">
                            <label class="PGSelect-Radios-Item d-block border rounded {{ readonly ? 'bg-grey' : 'bg-white' }}">
                                <div>
                                    <app-pg-switch [readonly]="readonly || option.disabled" [small]="true" [little]="true" [value]="option.value" [ariaLabel]="option.view | stripHTML" [ngModel]="value" (ngModelChange)="onSwitchChange($event, option)"></app-pg-switch>
                                    <div>
                                        <span [innerHTML]="option.view"></span>
                                        @if (option.tooltip) {
                                            <div class="form-text text-muted">{{option.tooltip}}</div>
                                        }
                                    </div>
                                </div>
                            </label>
                        </div>
                    }
                }
                <!-- Perdoname madre por mi vida lamer -->
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
                <div class="PGSelect-FlexFixPseudoElement"></div>
            </div>
        </span>
    }
    @if (viewAs == 'select') {
        <span ngbDropdown [autoClose]="false" class="PGSelect-Select">
            <div ngbDropdownAnchor class="position-relative">
                <input #inputElement class="form-control PGSelect-Select-Input {{hasFocus && !hasSearch ? 'focus' : ''}}"
                    [attr.id]="fieldId || null"
                    [attr.aria-label]="ariaLabel || null"
                    role="combobox"
                    aria-autocomplete="list"
                    [attr.aria-expanded]="isDropdownOpen"
                    [attr.aria-controls]="'pg-select-listbox-' + (fieldId || 'default')"
                    aria-haspopup="listbox"
                    readonly="readonly" [tabIndex]="hasSearch ? -1 : null" [ngModel]="text | stripHTML"
                    (focus)="onInputFocus()" (focusout)="onInputBlur()" (keypress)="onKeyPress($event)"/>
                    @if (hasSearch) {
                        <input #searchInputElement placeholder="{{ 'pg-select.search' | locTranslate }}"
                            class="form-control PGSelect-Select-Search {{hasFocus ? 'PGSelect-Select-Search--ShowSearch' : ''}}"
                            [readonly]="readonly" [tabIndex]="!hasSearch ? -1 : null" [(ngModel)]="search"
                            [attr.aria-label]="'pg-select.search' | locTranslate"
                            role="combobox"
                            aria-autocomplete="list"
                            [attr.aria-expanded]="isDropdownOpen"
                            [attr.aria-controls]="'pg-select-listbox-' + (fieldId || 'default')"
                            (focus)="onInputFocus()" (focusout)="onInputBlur()" (keypress)="onKeyPress($event)"/>
                    }
                    <div class="PGSelect-Select-Wrap" aria-hidden="true">
                        <div class="PGSelect-Select-Display border">
                            <span class="{{hasFocus && hasSearch ? 'd-none' : ''}} {{ !text ? 'text-muted' : '' }}" [innerHTML]="text || placeholder || '-'"></span>
                        </div>
                        <div class="PGSelect-Select-Button input-group-text">
                            <i class="fa-regular fa-angle-down"></i>
                        </div>
                    </div>
                </div>
                @if (isLoading) {
                    <div class="PGSelect-Select-Loading" pgAnimations="FadeIn">
                        <app-pg-loading></app-pg-loading>
                    </div>
                }
                <div ngbDropdownMenu class="dropdown-menu PGSelect-Select-Dropdown {{multi && selectedOptions.length > 0  ? 'PGSelect-Select-Dropdown--HasMulti' : ''}} {{isDropdownClosing ? 'pg-animation-fadeout' : 'pg-animation-fadein'}} {{forcedPlacement === 'right-bottom' ? 'PGSelect-Select-Dropdown-ForcedRightBottom' : ''}}" role="listbox" [attr.id]="'pg-select-listbox-' + (fieldId || 'default')" [attr.aria-multiselectable]="multi || null">
                    @if (isDropdownLoading) {
                        <app-pg-loading pgAnimations="FadeIn" [isOverlay]="true"></app-pg-loading>
                    }
                    <span class="PGSelect-Select-Dropdown-Multi border-bottom">
                        @for (selected of selectedOptions; track selected) {
                            @if (!isOptionIgnored(selected)) {
                                <div class="dropdown-item" role="option" [attr.aria-selected]="true" (mousedown)="deselectOption(selected)">
                                    <span [innerHTML]="selected.view"></span>
                                    <span class="ms-2">
                                        <i class="fa-regular fa-times text-danger m-0" aria-hidden="true"></i>
                                    </span>
                                    <span class="visually-hidden">{{ 'pg-select.remove-option' | locTranslate }}</span>
                                </div>
                            }
                        }
                    </span>
                    <span class="PGSelect-Select-Dropdown-Options">
                        <!-- NB: sulle options ho usato il mousedown come evento perché il click dava problemi "strani" -->
                        @if (!required && !multi) {
                            <div class="dropdown-item" role="option" [attr.aria-selected]="selectedOptions.length == 0" (mousedown)="selectOption()" [innerHTML]="noSelectionText || '-'"></div>
                        }
                        @if (getVisibleOptions(); as visibleOptions) {
                            @if (visibleOptions.length == 0) {
                                <div class="dropdown-item disabled" role="presentation">
                                    @if (showSearchMin()) {
                                        {{ 'pg-select.search-min' | locTranslate:'min':searchMin }}
                                    }
                                    @if (!showSearchMin()) {
                                        {{ 'pg-select.no-result' | locTranslate }}
                                    }
                                </div>
                            }
                            @for (option of visibleOptions; track option; let i = $index) {
                                @if (showCategoryBefore(i); as category) {
                                    <div class="PGSelect-Select-Dropdown-Options-Category border-bottom" role="presentation">{{category}}</div>
                                }
                                <div class="dropdown-item {{isOptionDisabled(option) ? 'disabled' : ''}} {{isOptionSelected(option) ? 'active' : ''}}"
                                    role="option"
                                    [attr.aria-selected]="isOptionSelected(option)"
                                    [attr.aria-disabled]="isOptionDisabled(option) || null"
                                    (mousedown)="selectOption(option)">
                                    <span [innerHTML]="option.view"></span>
                                    @if (option.tooltip) {
                                        <div class="small text-dark">{{option.tooltip}}</div>
                                    }
                                </div>
                            }
                        }
                        <app-pg-view-more [hidden]="!isIncomplete || isDropdownLoading" (viewMore)="loadMore()"></app-pg-view-more>
                    </span>
                </div>
            </span>
        }
    </span>
